import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledDescription = styled(Text)`
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	opacity: 0.75;
`;

const StyledInputs = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 10px;
	margin-top: 10px;
`;

export {
	StyledButtonsContainer,
	StyledDescription,
	StyledInputs,
	StyledModalBody,
};
